var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "section" },
    [
      _c("div", { staticClass: "container" }, [
        _c(
          "div",
          { staticClass: "level" },
          [
            _c(
              "Header",
              _vm._b(
                { staticClass: "level-left" },
                "Header",
                _vm.$route.meta,
                false
              )
            ),
            _c(
              "b-button",
              {
                staticClass: "left-right",
                attrs: {
                  type: "is-success",
                  "icon-left": "plus",
                  disabled: _vm.selectedPlant === null || _vm.isLoading,
                },
                on: {
                  click: function ($event) {
                    return _vm.showCreateForm()
                  },
                },
              },
              [_vm._v(" New Accident ")]
            ),
          ],
          1
        ),
        _c("div", { staticClass: "columns" }, [
          _c(
            "div",
            { staticClass: "column" },
            [
              _c(
                "b-field",
                { attrs: { grouped: "" } },
                [
                  _c(
                    "b-field",
                    { attrs: { label: "Start Date" } },
                    [
                      _c("b-datepicker", {
                        attrs: {
                          name: "startdate",
                          "first-day-of-week": 1,
                          locale: "en-CA",
                          icon: "calendar-alt",
                          placeholder: "Start date",
                        },
                        model: {
                          value: _vm.start,
                          callback: function ($$v) {
                            _vm.start = $$v
                          },
                          expression: "start",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-field",
                    { attrs: { label: "End Date" } },
                    [
                      _c("b-datepicker", {
                        attrs: {
                          name: "enddate",
                          "first-day-of-week": 1,
                          locale: "en-CA",
                          icon: "calendar-alt",
                          placeholder: "End date",
                        },
                        model: {
                          value: _vm.end,
                          callback: function ($$v) {
                            _vm.end = $$v
                          },
                          expression: "end",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.user.group.plants && _vm.user.group.plants.length != 0
                    ? _c(
                        "b-field",
                        { attrs: { label: "Plant" } },
                        [
                          _c(
                            "b-select",
                            {
                              attrs: { icon: "industry", expanded: "" },
                              model: {
                                value: _vm.selectedPlant,
                                callback: function ($$v) {
                                  _vm.selectedPlant = $$v
                                },
                                expression: "selectedPlant",
                              },
                            },
                            _vm._l(_vm.user.group.plants, function (plant) {
                              return _c(
                                "option",
                                { key: plant.id, domProps: { value: plant } },
                                [_vm._v(" " + _vm._s(plant.name) + " ")]
                              )
                            }),
                            0
                          ),
                        ],
                        1
                      )
                    : _c(
                        "b-field",
                        { attrs: { label: "Plant" } },
                        [
                          _c("multiselect", {
                            staticStyle: { "min-width": "400px" },
                            attrs: {
                              options: _vm.plants,
                              multiple: false,
                              "close-on-select": true,
                              placeholder: "Pick plant",
                              "custom-label": (obj) =>
                                obj.id + " - " + obj.name,
                              "track-by": "name",
                            },
                            model: {
                              value: _vm.selectedPlant,
                              callback: function ($$v) {
                                _vm.selectedPlant = $$v
                              },
                              expression: "selectedPlant",
                            },
                          }),
                        ],
                        1
                      ),
                ],
                1
              ),
              _c(
                "b-field",
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "left-right",
                      attrs: {
                        type: "is-warning",
                        "icon-left": "arrows-rotate",
                        disabled: _vm.isLoading || _vm.selectedPlant === null,
                      },
                      on: {
                        click: () => {
                          _vm.resetData()
                          _vm.getData()
                        },
                      },
                    },
                    [_vm._v(" Load ")]
                  ),
                ],
                1
              ),
              _vm.accident.length != 0
                ? _c("ag-grid-vue", {
                    staticClass: "ag-theme-balham",
                    staticStyle: { width: "100%", height: "700px" },
                    attrs: {
                      "row-data": _vm.accident,
                      "grid-options": _vm.gridOptions,
                      pagination: true,
                      "pagination-auto-page-size": true,
                      "cache-overflow-size": 0,
                      "multi-sort-key": "ctrl",
                      modules: _vm.modules,
                      "get-context-menu-items": _vm.getContextMenuItems,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]),
      ]),
      _c(
        "b-modal",
        {
          attrs: {
            active: _vm.isCreatingAccident,
            scroll: "keep",
            "has-modal-card": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.isCreatingAccident = $event
            },
          },
        },
        [
          _vm.isCreatingAccident
            ? _c(
                "form",
                {
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.submitAccident.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "modal-card",
                      staticStyle: {
                        "min-width": "50vw",
                        width: "fit-content",
                        "min-height": "50vh",
                        height: "fit-content",
                      },
                    },
                    [
                      _c("header", { staticClass: "modal-card-head" }, [
                        _c("p", { staticClass: "modal-card-title" }, [
                          _vm._v(" Create Accident "),
                          _vm.selectedPlant
                            ? _c(
                                "span",
                                {
                                  staticStyle: {
                                    "font-size": "1rem",
                                    "text-overflow": "elipsis",
                                  },
                                },
                                [_vm._v(_vm._s(_vm.selectedPlant.name))]
                              )
                            : _vm._e(),
                        ]),
                      ]),
                      _c(
                        "section",
                        { staticClass: "modal-card-body" },
                        [
                          _c(
                            "b-field",
                            { attrs: { grouped: "" } },
                            [
                              _c(
                                "b-field",
                                { attrs: { label: "Date" } },
                                [
                                  _c("b-datepicker", {
                                    attrs: {
                                      name: "newdate",
                                      "first-day-of-week": 1,
                                      locale: "en-CA",
                                      icon: "calendar-alt",
                                    },
                                    model: {
                                      value: _vm.newAccident.date,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.newAccident, "date", $$v)
                                      },
                                      expression: "newAccident.date",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "Shift" } },
                            [
                              _c(
                                "b-select",
                                {
                                  model: {
                                    value: _vm.newAccident.shift,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.newAccident, "shift", $$v)
                                    },
                                    expression: "newAccident.shift",
                                  },
                                },
                                [
                                  _c("option", { attrs: { value: "AM" } }, [
                                    _vm._v(" AM "),
                                  ]),
                                  _c("option", { attrs: { value: "PM" } }, [
                                    _vm._v(" PM "),
                                  ]),
                                  _c("option", { attrs: { value: "Night" } }, [
                                    _vm._v(" Night "),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "Reporter" } },
                            [
                              _c(
                                "b-select",
                                {
                                  model: {
                                    value: _vm.newAccident.reporter_id,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.newAccident,
                                        "reporter_id",
                                        $$v
                                      )
                                    },
                                    expression: "newAccident.reporter_id",
                                  },
                                },
                                [
                                  _c("option", { attrs: { value: "" } }, [
                                    _vm._v(" None "),
                                  ]),
                                  _vm._l(_vm.employees, function (employee) {
                                    return _c(
                                      "option",
                                      {
                                        key: "new" + employee.id,
                                        domProps: { value: employee.id },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              employee.name +
                                                " " +
                                                employee.surname
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  }),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "Involved" } },
                            [
                              _c("multiselect", {
                                staticStyle: { "min-width": "400px" },
                                attrs: {
                                  options: _vm.employees,
                                  multiple: true,
                                  "close-on-select": false,
                                  placeholder: "Select Employees",
                                  "custom-label": (obj) =>
                                    obj.name + " " + obj.surname,
                                  "track-by": "name",
                                },
                                model: {
                                  value: _vm.newAccident.involved_id,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.newAccident,
                                      "involved_id",
                                      $$v
                                    )
                                  },
                                  expression: "newAccident.involved_id",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "Type" } },
                            [
                              _c(
                                "b-select",
                                {
                                  model: {
                                    value: _vm.newAccident.type,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.newAccident, "type", $$v)
                                    },
                                    expression: "newAccident.type",
                                  },
                                },
                                [
                                  _c(
                                    "option",
                                    { attrs: { value: "dangerous situation" } },
                                    [_vm._v(" dangerous situation ")]
                                  ),
                                  _c(
                                    "option",
                                    { attrs: { value: "near miss" } },
                                    [_vm._v(" near miss ")]
                                  ),
                                  _c(
                                    "option",
                                    { attrs: { value: "minor accident" } },
                                    [_vm._v(" minor accident ")]
                                  ),
                                  _c("option", { attrs: { value: "AT WLT" } }, [
                                    _vm._v(" AT WLT "),
                                  ]),
                                  _c("option", { attrs: { value: "AT LT" } }, [
                                    _vm._v(" AT LT "),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "Arret" } },
                            [
                              _c("b-input", {
                                attrs: { type: "number" },
                                model: {
                                  value: _vm.newAccident.arret,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.newAccident, "arret", $$v)
                                  },
                                  expression: "newAccident.arret",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "Comment" } },
                            [
                              _c("b-input", {
                                attrs: { type: "text" },
                                model: {
                                  value: _vm.newAccident.comment,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.newAccident, "comment", $$v)
                                  },
                                  expression: "newAccident.comment",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("footer", { staticClass: "modal-card-foot" }, [
                        _c(
                          "button",
                          {
                            staticClass: "button is-info is-fullwidth",
                            attrs: { type: "submit" },
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("global.submit")) + " ")]
                        ),
                      ]),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ]
      ),
      _c(
        "b-modal",
        {
          attrs: {
            active: _vm.isEditingAccident,
            scroll: "keep",
            "has-modal-card": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.isEditingAccident = $event
            },
          },
        },
        [
          _vm.isEditingAccident
            ? _c(
                "form",
                {
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.submitEdit.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "modal-card",
                      staticStyle: {
                        "min-width": "50vw",
                        width: "fit-content",
                        "min-height": "50vh",
                        height: "fit-content",
                      },
                    },
                    [
                      _c("header", { staticClass: "modal-card-head" }, [
                        _c("p", { staticClass: "modal-card-title" }, [
                          _vm._v(" Edit Accident "),
                          _vm.selectedPlant
                            ? _c(
                                "span",
                                {
                                  staticStyle: {
                                    "font-size": "1rem",
                                    "text-overflow": "elipsis",
                                  },
                                },
                                [_vm._v(_vm._s(_vm.selectedPlant.name))]
                              )
                            : _vm._e(),
                        ]),
                      ]),
                      _c(
                        "section",
                        { staticClass: "modal-card-body" },
                        [
                          _c(
                            "b-field",
                            { attrs: { grouped: "" } },
                            [
                              _c(
                                "b-field",
                                { attrs: { label: "Date" } },
                                [
                                  _c("b-datepicker", {
                                    attrs: {
                                      name: "newdate",
                                      "first-day-of-week": 1,
                                      locale: "en-CA",
                                      icon: "calendar-alt",
                                    },
                                    model: {
                                      value: _vm.editableAccident.date,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.editableAccident,
                                          "date",
                                          $$v
                                        )
                                      },
                                      expression: "editableAccident.date",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "Shift" } },
                            [
                              _c(
                                "b-select",
                                {
                                  model: {
                                    value: _vm.editableAccident.shift,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.editableAccident,
                                        "shift",
                                        $$v
                                      )
                                    },
                                    expression: "editableAccident.shift",
                                  },
                                },
                                [
                                  _c("option", { attrs: { value: "AM" } }, [
                                    _vm._v(" AM "),
                                  ]),
                                  _c("option", { attrs: { value: "PM" } }, [
                                    _vm._v(" PM "),
                                  ]),
                                  _c("option", { attrs: { value: "Night" } }, [
                                    _vm._v(" Night "),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "Reporter" } },
                            [
                              _c(
                                "b-select",
                                {
                                  model: {
                                    value: _vm.editableAccident.reporter_id,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.editableAccident,
                                        "reporter_id",
                                        $$v
                                      )
                                    },
                                    expression: "editableAccident.reporter_id",
                                  },
                                },
                                [
                                  _c("option", { attrs: { value: "" } }, [
                                    _vm._v(" None "),
                                  ]),
                                  _vm._l(_vm.employees, function (employee) {
                                    return _c(
                                      "option",
                                      {
                                        key: "edit" + employee.id,
                                        domProps: { value: employee.id },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              employee.name +
                                                " " +
                                                employee.surname
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  }),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "Involved" } },
                            [
                              _c("multiselect", {
                                staticStyle: { "min-width": "400px" },
                                attrs: {
                                  options: _vm.employees,
                                  multiple: true,
                                  "close-on-select": false,
                                  placeholder: "Select Employees",
                                  "custom-label": (obj) =>
                                    obj.name + " " + obj.surname,
                                  "track-by": "name",
                                },
                                model: {
                                  value: _vm.editableAccident.involved_id,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.editableAccident,
                                      "involved_id",
                                      $$v
                                    )
                                  },
                                  expression: "editableAccident.involved_id",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "Type" } },
                            [
                              _c(
                                "b-select",
                                {
                                  model: {
                                    value: _vm.editableAccident.type,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.editableAccident,
                                        "type",
                                        $$v
                                      )
                                    },
                                    expression: "editableAccident.type",
                                  },
                                },
                                [
                                  _c(
                                    "option",
                                    { attrs: { value: "dangerous situation" } },
                                    [_vm._v(" dangerous situation ")]
                                  ),
                                  _c(
                                    "option",
                                    { attrs: { value: "near miss" } },
                                    [_vm._v(" near miss ")]
                                  ),
                                  _c(
                                    "option",
                                    { attrs: { value: "minor accident" } },
                                    [_vm._v(" minor accident ")]
                                  ),
                                  _c("option", { attrs: { value: "AT WLT" } }, [
                                    _vm._v(" AT WLT "),
                                  ]),
                                  _c("option", { attrs: { value: "AT LT" } }, [
                                    _vm._v(" AT LT "),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "Arret" } },
                            [
                              _c("b-input", {
                                attrs: { type: "number" },
                                model: {
                                  value: _vm.editableAccident.arret,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.editableAccident, "arret", $$v)
                                  },
                                  expression: "editableAccident.arret",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "Comment" } },
                            [
                              _c("b-input", {
                                attrs: { type: "text" },
                                model: {
                                  value: _vm.editableAccident.comment,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.editableAccident,
                                      "comment",
                                      $$v
                                    )
                                  },
                                  expression: "editableAccident.comment",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("footer", { staticClass: "modal-card-foot" }, [
                        _c(
                          "button",
                          {
                            staticClass: "button is-info is-fullwidth",
                            attrs: { type: "submit" },
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("global.submit")) + " ")]
                        ),
                      ]),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }